/**
 * Formato de importes para toda la tienda.
 *
 * Estaba repetido como `toFixed(2)` en once sitios, que imprime punto decimal:
 * «20.00 €» en lugar de «20,00 €». Además de ser incorrecto en español, no
 * coincidía con el correo de confirmación del pedido, que usa Intl y sí pone coma.
 *
 * El importe va en euros, no en céntimos: los céntimos solo existen en el servidor
 * y en Stripe.
 */
const euro = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

export function formatEuro(amount: number) {
  return euro.format(amount);
}
